import { render, staticRenderFns } from "./CustomSelectBox.vue?vue&type=template&id=1a9f07a4&"
import script from "./CustomSelectBox.vue?vue&type=script&lang=js&"
export * from "./CustomSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports